<template>
  <div class="flex items-center gap-2 flex-wrap">
    <span class="text-xs text-gray-400 shrink-0">Formatter</span>
    <BuilderSelect class="text-sm px-1 py-1 shrink-0" v-model="formatter.type" @change="onTypeChange">
      <option v-for="(meta, type) in FORMATTER_TYPES" :key="type" :value="type">{{ meta.label }}</option>
    </BuilderSelect>

    <div v-for="paramDef in FORMATTER_TYPES[formatter.type]?.params ?? []" :key="paramDef.key"
      class="flex items-center gap-1 shrink-0">
      <span class="text-xs text-gray-400">{{ paramDef.label }}</span>
      <BuilderSelect class="text-sm px-1 py-1" v-model="formatter.params[paramDef.key]">
        <option v-for="opt in paramDef.options" :key="opt" :value="opt">
          {{ paramDef.optionLabels?.[opt] ?? opt }}
        </option>
      </BuilderSelect>
    </div>
  </div>
</template>

<script setup>
/**
 * FormatterEditor.vue
 *
 * Editor for binding.formatter — a single formatter config, not a
 * pipeline (unlike TransformEditor.vue, whose type-select + per-type
 * param pattern this otherwise mirrors), so there's no add/remove/reorder.
 *
 * Deliberately not wrapped in a collapsible section and not styled as a
 * warning/advanced feature: an always-visible row that stays visually
 * minimal when type is 'none' (no extra controls render), so it reads as
 * another step in the binding pipeline rather than a separate workflow.
 *
 * Mounted only in StateBindingEditor.vue — Mapping is intentionally
 * excluded (its output is always the matched rule's own literal, not a
 * retrieved value there's anything left to format).
 */
import { FORMATTER_TYPES, defaultParamsFor } from '../../../automation/schema/valueFormatters.js';
import BuilderSelect from './BuilderSelect.vue';

const props = defineProps({
  formatter: { type: Object, required: true }, // binding.formatter — mutated directly
});

/** Resets a formatter's params when its type changes — old params won't match the new type's keys. */
function onTypeChange() {
  props.formatter.params = defaultParamsFor(props.formatter.type);
}
</script>
